import React, { Component } from 'react';
import './SubMenuHeader.css';
import ParameterErrors from '../errors/ParameterErrors';
import IconButton from './IconButton';
import { faBackward, faTimes} from '@fortawesome/free-solid-svg-icons'
import Urls from '../urls/Urls';
const{throwNotProvided}=ParameterErrors;
export default class SubMenuHeader extends Component {
	constructor(props){
		super(props);
		const {title, children}=props;
		this._children = children;
		this._hasChildren=children?true:false;
		this._handleClickButtonBack= this._handleClickButtonBack.bind(this);
		this._handleClickButtonClose= this._handleClickButtonClose.bind(this);
		this._iMenuManager = null;
		this.state ={title:title};
	}
	componentDidUpdate(previousProps){
		if(this.props.title!=this.state.title)
			this.setState({title:this.props.title});
	}
	_handleClickButtonBack(){
		if(this._iMenuManager)
			this._iMenuManager.back();
	}
	_handleClickButtonClose(){
		if(this._iMenuManager)
			this._iMenuManager.close();
	}
	setIMenuManager(value){
		this._iMenuManager = value;
	}
	render() {
		const className = "sub-menu-header"+(this._hasChildren?' has-children':'');
		return (<div className={className}>
			<div className="children">{this._children}</div>
			<div className="title">{this.state.title}</div>
			<div className="button-back-wrapper"> 
				<IconButton imgUrl ={Urls.assets+'icons/UI_Button_Open.png'} onClick={this._handleClickButtonBack}></IconButton>
			</div>
			<div className="button-close-wrapper" >
				<IconButton imgUrl ={Urls.assets+'icons/UI_Button_Exit.png'}  onClick={this._handleClickButtonClose}></IconButton>
			</div>
		</div>)
	}
}
